import React from 'react';
import { observer } from 'mobx-react';
import { Spring, animated } from 'react-spring';

import Title from './Title';
import Status from './Status';

export default observer(({ children }) => {
  return (
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
      {animation => (
        <animated.div style={animation}>
          <Title>STATUS</Title>
          <Status>{children}</Status>
        </animated.div>
      )}
    </Spring>
  );
});
